import React from "react";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useMyself } from "@api/v1/hooks/useMyself";
import { CONFIRMATION_EXPIRED_ERROR } from "@features/login/constants";
import { useResendRegistrationConfirmation } from "@rentablo/api/apiv1";
import { EmailConfirmationContainer } from "./EmailConfirmationContainer";

export const EmailConfirmation = () => {
  const { t } = useTranslation();
  const { data: user, isFetching, isPending } = useMyself();
  const {
    mutate,
    isPending: isMutating,
    isSuccess: isMutationSuccess,
    error: mutationError,
  } = useResendRegistrationConfirmation();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const isEmailConfirmationExpired = error === CONFIRMATION_EXPIRED_ERROR;

  const handleClick = () => {
    if (!user) {
      return;
    }
    mutate({ email: user?.email });
  };

  const isButtonLoading = error ? false : isFetching || isPending || isMutating;

  return (
    <EmailConfirmationContainer
      onResendEmail={handleClick}
      error={
        isEmailConfirmationExpired
          ? t("emailConfirmation.confirmationExpiredError")
          : mutationError?.message
      }
      isMutationSuccess={isMutationSuccess}
      isButtonLoading={isButtonLoading}
    />
  );
};
